"use client"


interface TitleSectionProps {
  onLoginClick?: () => void
}

export function TitleSection({ onLoginClick }: TitleSectionProps) {
  return (
    <div className="space-y-4">
      {/* 品牌行 */}
      <div className="flex items-center gap-2">
        <h1 className="text-2xl font-bold text-gray-900 leading-none">
          <span className="text-blue-600">easy-share</span>
        </h1>
        <span className="bg-blue-600 text-white text-[10px] px-2 py-0.5 rounded-full font-medium">云传</span>
      </div>

      {/* 主标题区 */}
      <div className="space-y-3">
        <div className="text-5xl md:text-6xl font-extrabold text-gray-900 tracking-tight">一站式</div>
        <div className="text-5xl md:text-6xl font-extrabold text-gray-900 tracking-tight">大文件传输平台</div>
      </div>

      {/* 副标题说明 */}
      <p className="text-sm md:text-base text-gray-600">端到端加密 · 链接/口令分享 · 自定义有效期</p>

      {/* CTA 文字 */}
      <span
        role="button"
        onClick={onLoginClick}
        className="inline-block text-blue-600 hover:text-blue-700 hover:underline text-base font-semibold cursor-pointer"
      >
        立即传输
      </span>
    </div>
  )
}
